module.exports = __webpack_public_path__ + "img/physical-work.1b34f356.png";